import { Question } from './question.types';

export enum SurveyTemplateTypes {
  FEEDBACK = 'feedback',
  EVENT_QUESTIONNAIRE = 'event_questionnaire'
}

export interface SurveyTemplate {
  id: string;
  title: string;
  description: string;
  creatorOnly: boolean;
  createdBy: number;
  creator: string;
  questions: Question[];
  isPublished: boolean;
  type: SurveyTemplateTypes;
  isArchived: boolean;
  editedAt: string;
  archivedAt: string;
  draftData?: string;
}

export type EditableSurveyTemplate = Partial<SurveyTemplate>;
